
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import NavBar from '@/components/NavBar';
import Footer from '@/components/Footer';

const ClubNotFound: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-background">
      <NavBar />
      <div className="container mx-auto p-4 flex-1">
        <div className="text-center my-12">
          <h2 className="text-2xl font-bold mb-2">Club Not Found</h2>
          <p className="text-muted-foreground mb-6">
            The club you're looking for doesn't exist or has been removed.
          </p>
          <Button onClick={() => navigate('/clubs')}>
            <ArrowLeft size={16} className="mr-2" /> Back to Clubs
          </Button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ClubNotFound;
